export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.2f7a8461.ttf";